import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MenuConfigurationDto } from '../../../../core/services/api-clients';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-main-menu-settings',
    templateUrl: './main-menu-settings.component.html',
    styleUrls: ['./main-menu-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIconButton,
        MatIcon,
        MatTooltip,
        TranslatePipe,
    ]
})
export class MainMenuSettingsComponent {
  readonly isWide = input<boolean>(false);
  readonly isAddFavoriteEnabled = input<boolean>(false);
  readonly menuConfiguration = input<MenuConfigurationDto>(undefined);

  readonly favoriteButtonClick = output<void>();
}
